import { render, staticRenderFns } from "./BookEventVirusTesting.vue?vue&type=template&id=495c7e7f&"
import script from "./BookEventVirusTesting.vue?vue&type=script&lang=js&"
export * from "./BookEventVirusTesting.vue?vue&type=script&lang=js&"
import style0 from "./BookEventVirusTesting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports